// src/components/layout/Loader.tsx
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import  logoImg  from '@/assets/Gaialogo_cuadrado_negro.svg';
import '@/styles/loader.css';

interface LoaderProps { visible: boolean }

export function Loader({ visible }: LoaderProps) {
  const [exiting, setExiting] = useState(false);
  const [mounted, setMounted]  = useState(visible);


  useEffect(() => {

    if (!visible) {
      setExiting(true);

      const t = setTimeout(() => setMounted(false), 800);
      return () => clearTimeout(t);
    }

    setMounted(true);
    setExiting(false);
  }, [visible]);


  if (!mounted) return null;


  return (
    <Box
      component="div"
      id="gaia-loader"
      className={`gaia-loader${exiting ? ' gaia-loader-exit' : ''}`}
      role="status"
      aria-label="Cargando"
      sx={{ zIndex: 9999 }}
    >
      <div className="gaia-loader-content">
        <img
          src={logoImg}
          alt="Gaia Amazonas"
          className="gaia-loader-logo"
          loading="eager"
        />
        <div className="gaia-loader-pulse" />
      </div>
    </Box>
  );
}